<template>
<span>
    <el-popover width="450" trigger="click" ref="rangeFilter" v-model="popoverVisible">
        <el-radio-group v-model="dateType" class="mr-b10 ordinary">
          <el-radio-button label="quick">빠른 시간 선택</el-radio-button>
          <el-radio-button label="absolute">사용자 정의 시간 선택</el-radio-button>
        </el-radio-group>

        <el-row v-show="dateType == 'quick'" type="flex" :gutter="4">
          <el-col :sapn="6" v-for="dateGroup in quickDatetime" :key="`${dateGroup[0].label}.Group`">
            <el-button :class="$style.quick_datetime_button" type="content" v-for="datetime in dateGroup" :key="datetime.label" @click="onClickDate(datetime)"
              v-show="filterDayValue(datetime)"> {{ datetime.label }}
            </el-button>
          </el-col>
        </el-row>

        <div v-show="dateType == 'absolute'">
          <el-row :class="$style['margin-b-10']" style="height: 50%" type="flex">
            <el-date-picker :class="$style.margin_r" v-model="absoluteDatetime.startDate" type="date" placeholder="시작 날짜" format="yyyy-MM-dd" :picker-options="{ disabledDate }" />
            <el-time-picker :class="$style.time_picker_width" v-model="absoluteDatetime.startTime" placeholder="00:00" format="HH:mm" value-format="HH:mm" :picker-options="{format : 'HH:mm'}" />
          </el-row>
          <el-row :class="$style['margin-b-10']" style="height: 50%" type="flex">
            <el-date-picker :class="$style.margin_r" v-model="absoluteDatetime.endDate" type="date" placeholder="종료 날짜" format="yyyy-MM-dd" :picker-options="{ disabledDate }"/>
            <el-time-picker :class="$style.time_picker_width" v-model="absoluteDatetime.endTime" placeholder="23:59" format="HH:mm" value-format="HH:mm" :picker-options="{format : 'HH:mm'}"/>
          </el-row>
          <el-row type="flex" justify="end">
            <el-button type="solid" @click="onClickAbsoluteButton">확인</el-button>
          </el-row>
        </div>

    </el-popover>
    <el-button size="medium" type="content" v-popover:rangeFilter :disabled="disabled">
        <img src="@/assets/img/icons/recent.png" style="position:relative;left:-2px; vertical-align: sub;"> {{ dateTimeRange.label }}
    </el-button>
  </span>
</template>

<script>
import { mapGetters } from 'vuex';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import parseInt from 'lodash/parseInt';
import find from 'lodash/find';
import flattenDepth from 'lodash/flattenDepth';
import forIn from 'lodash/forIn';
import clone from 'lodash/clone';

import moment from 'moment';

import { getRequestDatetimeParams, getIntervalDatetimeParams } from '@/utils/date';

export default {
  name: 'WDatetimeRangeButton',
  props: {
    isFlowAnalysis: {
      type: Boolean,
    },
    defaultDateTimeRange: {
      type: Object,
      default() {
        return {
          type: 'interval',
          interval: 'hour',
          value: 12,
          isRelative: false,
          label: '최근 12시간',
        };
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    maxDayValue: Number,
    isRelativeOnly: {
      type: Boolean,
      default: false,
    },
    isInDashboardWidget: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      popoverVisible: false,
      dateType: 'quick',
      selectedDatetime: {},
      dateTimeRange: this.defaultDateTimeRange,
      defualtQuickDatetime: [
        [
          {
            type: 'fixed',
            value: 'today',
            label: '오늘',
            dayValue: 1,
          },
          {
            type: 'fixed',
            value: 'thisWeek',
            label: '이번 주',
            dayValue: 7,
          },
          {
            type: 'fixed',
            value: 'thisMonth',
            label: '이번 달',
            dayValue: 31,
          },
          {
            type: 'fixed',
            value: 'thisYear',
            label: '올해',
            dayValue: 365,
          },
          {
            type: 'fixed',
            value: 'weekToDate',
            label: '현재까지 주간',
            dayValue: 7,
          },
          {
            type: 'fixed',
            value: 'monthToDate',
            label: '현재까지 월간',
            dayValue: 31,
          },
          {
            type: 'fixed',
            value: 'yearToDate',
            label: '현재까지 연간',
            dayValue: 365,
          },
        ],
        [
          {
            type: 'fixed',
            value: 'yesterday',
            label: '어제',
            dayValue: 1,
          },
          {
            type: 'fixed',
            value: 'beforeYesterday',
            label: '그제',
            dayValue: 1,
          },
          {
            type: 'fixed',
            value: 'todayLastWeek',
            label: '지난 주 오늘',
            dayValue: 1,
          },
          {
            type: 'fixed',
            value: 'lastWeek',
            label: '전 주',
            dayValue: 7,
          },
          {
            type: 'fixed',
            value: 'lastMonth',
            label: '전 월',
            dayValue: 31,
          },
          {
            type: 'fixed',
            value: 'lastYear',
            label: '전 년',
            dayValue: 365,
          },
        ],
        [
          {
            type: 'interval',
            interval: 'minute',
            value: 15,
            isRelative: true,
            label: '최근 15분',
            dayValue: 0.01,
          },
          {
            type: 'interval',
            interval: 'minute',
            value: 30,
            isRelative: true,
            label: '최근 30분',
            dayValue: 0.02,
          },
          {
            type: 'interval',
            interval: 'hour',
            value: 1,
            isRelative: true,
            label: '최근 1시간',
            dayValue: 0.04,
          },
          {
            type: 'interval',
            interval: 'hour',
            value: 6,
            isRelative: true,
            label: '최근 6시간',
            dayValue: 0.25,
          },
          {
            type: 'interval',
            interval: 'hour',
            value: 12,
            isRelative: false,
            label: '최근 12시간',
            dayValue: 0.5,
          },
          {
            type: 'interval',
            interval: 'hour',
            value: 24,
            isRelative: false,
            label: '최근 24시간',
            dayValue: 1,
          },
        ],
        [
          {
            type: 'interval',
            interval: 'day',
            value: 7,
            label: '최근 7일',
            dayValue: 7,
          },
          {
            type: 'interval',
            interval: 'day',
            value: 30,
            label: '최근 30일',
            dayValue: 30,
          },
          {
            type: 'interval',
            interval: 'day',
            value: 60,
            label: '최근 60일',
            dayValue: 60,
          },
          {
            type: 'interval',
            interval: 'day',
            value: 90,
            label: '최근 90일',
            dayValue: 90,
          },
          {
            type: 'interval',
            interval: 'month',
            value: 6,
            label: '최근 6개월',
            dayValue: 183,
          },
          {
            type: 'interval',
            interval: 'year',
            value: 1,
            label: '최근 1년',
            dayValue: 365,
          },
        ],
      ],
      flowQuickDatetime: [
        [
          {
            type: 'interval',
            interval: 'minute',
            value: 10,
            isRelative: true,
            label: '최근 10분',
          },
          {
            type: 'interval',
            interval: 'minute',
            value: 30,
            isRelative: true,
            label: '최근 30분',
          },
          {
            type: 'interval',
            interval: 'hour',
            value: 1,
            isRelative: true,
            label: '최근 1시간',
          },
          {
            type: 'interval',
            interval: 'hour',
            value: 2,
            isRelative: true,
            label: '최근 2시간',
          },
        ],
        [
          {
            type: 'interval',
            interval: 'hour',
            value: 6,
            isRelative: true,
            label: '최근 6시간',
          },
          {
            type: 'interval',
            interval: 'hour',
            value: 12,
            isRelative: true,
            label: '최근 12시간',
          },
          {
            type: 'interval',
            interval: 'hour',
            value: 24,
            isRelative: false,
            label: '최근 24시간',
          },
        ],
      ],
      absoluteDatetime: {
        startDate: new Date(),
        startTime: '00:00',
        endDate: new Date(),
        endTime: '23:59',
      },
    };
  },
  computed: {
    quickDatetime() {
      if (this.isFlowAnalysis) {
        return this.flowQuickDatetime;
      }
      return this.defualtQuickDatetime;
    },
    /**
     * 빠른 시간을 선택할 때 마다 startDatetime과 endDatetime을 생성한다.
     * @author jda
     * @return {[type]} [description]
     */
    ...mapGetters(['initialDatetimeRange']),
  },
  watch: {
    dateTimeRange: {
      handler(value) {
        if (!isNil(value)) {
          const datetimeData = value.data;
          const startDatetime = new Date(datetimeData.startValue);
          const endDatetime = new Date(datetimeData.endValue);
          this.absoluteDatetime = {
            startDate: startDatetime,
            startTime: moment(startDatetime).format('HH:mm'),
            endDate: endDatetime,
            endTime: moment(endDatetime).format('HH:mm'),
            label: `${datetimeData.startLabel} ~ ${datetimeData.endLabel}`,
          };
        }
      },
    },
    /**
     * 기간 필터 컴포넌트 초기 값이 설정되어있는 경우 해당 값 기준으로 컴포넌트 및 분석 기간 설정되도록 처리
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     * @author jda
     */
    initialDatetimeRange: {
      immediate: true,
      handler(value) {
        if (!isNil(value)) {
          let dateTimeRange;
          if (value.type === 'absolute') {
            this.dateType = 'absolute';
            const startDatetime = moment(value.startDatetime);
            const endDatetime = moment(value.endDatetime);
            const timeFormat = 'HH:mm';
            this.absoluteDatetime = {
              startDate: startDatetime.toDate(),
              startTime: startDatetime.format(timeFormat),
              endDate: endDatetime.toDate(),
              endTime: endDatetime.format(timeFormat),
            };
            this.onClickAbsoluteButton();
          } else {
            this.dateType = 'quick';
            dateTimeRange = find(flattenDepth(this.quickDatetime), value);
            this.onClickDate(dateTimeRange);
          }
          this.$store.dispatch('setInitialDatetimeRange', null);
        }
      },
    },
    /**
     * [성능/운영 > Flow 분석]일 경우 default값은 [최근 1시간]으로 설정.
     * 나머지는 [최근 12시간]으로 설정한다.
     * @param  {Boolean} isFlowAnalysis [description]
     * @return {Boolean}           [description]
     * @author jda
     */
    isFlowAnalysis(isFlowAnalysis) {
      let datetimeRange = {
        type: 'interval',
        interval: 'hour',
        value: 12,
        isRelative: false,
        label: '최근 12시간',
      };
      if (isFlowAnalysis) {
        datetimeRange = {
          type: 'interval',
          interval: 'hour',
          value: 1,
          isRelative: true,
          label: '최근 1시간',
        };
      }
      this.onClickDate(datetimeRange);
    },
  },
  mounted() {
    if (isEmpty(this.selectedDatetime)) {
      this.setSelectedDateTime(this.defaultDateTimeRange, 'defalut');
    }
  },
  methods: {
    /**
     * 빠른 시간을 선택 하거나 사용자 정의 시간을 선택할 때 실행 된다.
     * @author jda
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    onClickDate(value) {
      this.setSelectedDateTime(value, 'click');
    },
    setSelectedDateTime(value, setType) {
      this.popoverVisible = false;
      this.selectedDatetime = value;
      this.setDateTimeRange(setType);
    },
    /**
     * 빠른 시간 선택의 datetimeRange객체를 생성한다.
     * @author jda
     */
    setDateTimeRange(setType) {
      const dateObject = this.selectedDatetime;
      const datetimeValue = this.getDatetimeValue(); // this.datetimeValue

      const datetimeLabelValue = this.setDateTimeToString(datetimeValue);
      const dateTimeRange = {
        type: this.dateType,
        label: this.dateType === 'absolute' ? `${datetimeLabelValue.startDatetime} ~ ${datetimeLabelValue.endDatetime}` : dateObject.label,
        params: this.setRequestDateTime(datetimeValue),
        data: {
          startValue: datetimeValue.startDatetime,
          startLabel: datetimeLabelValue.startDatetime,
          endValue: datetimeValue.endDatetime,
          endLabel: datetimeLabelValue.endDatetime,
        },
        isRelative: isNil(dateObject.isRelative) ? false : dateObject.isRelative,
      };

      if (!isNil(this.isRelativeOnly) && this.isRelativeOnly) {
        dateTimeRange.isRelative = true;
      }

      this.dateTimeRange = dateTimeRange;
      this.$store.dispatch('setAnalysisDateData', dateTimeRange);
      if (this.isInDashboardWidget && setType === 'click') {
        // 대시보드 성능추이차트에서 사용하기 위한 이벤트 발생
        this.$emit('changePeriod', dateTimeRange);
      }
    },
    /**
     * 선택한 기간 값에 맞는 시작/종료 일시 (Date-long) 정보 객체를 가공하여 반환한다.
     * @author Ju
     * @return {Object} startDatetime, endDatetime
     */
    getDatetimeValue() {
      const dateTimeObject = this.selectedDatetime;
      let startDatetime;
      let endDatetime;
      let type;
      const today = new Date();

      if (dateTimeObject.type === 'fixed') {
        switch (dateTimeObject.value) {
          case 'today': {
            startDatetime = new Date(today);
            endDatetime = new Date(today);
            break;
          }
          case 'thisWeek': {
            const period = today.getDate() - today.getDay();
            startDatetime = new Date(today.setDate(period));
            endDatetime = new Date(today.setDate(startDatetime.getDate() + 6));
            break;
          }
          case 'thisMonth': {
            startDatetime = new Date(today.setDate(1));
            endDatetime = new Date(today.getFullYear(), today.getMonth() + 1, 0);
            break;
          }
          case 'thisYear': {
            startDatetime = new Date(today.getFullYear(), 0, 1);
            endDatetime = new Date(today.getFullYear(), 12, 0);
            break;
          }
          case 'weekToDate': {
            startDatetime = new Date(today.setDate(today.getDate() - today.getDay()));
            endDatetime = new Date();
            type = 'todate';
            break;
          }
          case 'monthToDate': {
            startDatetime = new Date(today.setDate(1));
            endDatetime = new Date();
            type = 'todate';
            break;
          }
          case 'yearToDate': {
            startDatetime = new Date(today.getFullYear(), 0, 1);
            endDatetime = new Date();
            type = 'todate';
            break;
          }
          case 'yesterday': {
            const yesterday = today.setDate(today.getDate() - 1);
            startDatetime = new Date(yesterday);
            endDatetime = new Date(yesterday);
            break;
          }
          case 'beforeYesterday': {
            const yesterday = today.setDate(today.getDate() - 2);
            startDatetime = new Date(yesterday);
            endDatetime = new Date(yesterday);
            break;
          }
          case 'todayLastWeek': {
            const todayLastWeek = today.setDate(today.getDate() - 7);
            startDatetime = new Date(todayLastWeek);
            endDatetime = new Date(todayLastWeek);
            break;
          }
          case 'lastWeek': {
            const period = today.getDate() - today.getDay() - 7;

            startDatetime = new Date(today.setDate(period));
            endDatetime = new Date(today.setDate(startDatetime.getDate() + 6));
            break;
          }
          case 'lastMonth': {
            startDatetime = new Date(today.getFullYear(), today.getMonth() - 1, 1);
            endDatetime = new Date(today.getFullYear(), today.getMonth(), 0);
            break;
          }
          case 'lastYear': {
            startDatetime = new Date(today.getFullYear() - 1, 0, 1);
            endDatetime = new Date(today.getFullYear() - 1, 12, 0);
            break;
          }
          default:
            break;
        }

        startDatetime.setHours(0, 0, 0);
        if (isEmpty(type)) {
          endDatetime.setHours(23, 59, 59);
        }

        return {
          startDatetime: startDatetime.getTime(),
          endDatetime: endDatetime.getTime(),
        };
      } else if (dateTimeObject.type === 'interval') {
        startDatetime = getIntervalDatetimeParams(new Date().getTime(), dateTimeObject.interval, dateTimeObject.value);
        endDatetime = new Date().getTime();
        return {
          startDatetime,
          endDatetime,
        };
      }
      // 사용자 정의 시간 선택 시
      this.setAbsoluteDatetime();
      const absoluteDatetime = this.absoluteDatetime;

      return {
        startDatetime: new Date(absoluteDatetime.startDate).getTime(),
        endDatetime: new Date(absoluteDatetime.endDate).getTime(),
      };
    },
    /**
     * datetime을 String형식으로 변환한다.
     * @author jda
     * @param  {[type]} datetimeObject [description]
     */
    setDateTimeToString(datetimeObject) {
      const datetimeLabelValue = {};
      forIn(datetimeObject, (value, key) => {
        datetimeLabelValue[key] = moment(value).format('YYYY-MM-DD HH:mm');
      });

      return datetimeLabelValue;
    },
    /**
     * 서버로 요청할 datetime을 만든다. (endDatetime + 1seconds)
     * @author jda
     * @param  {[type]} datetimeObject [description]
     */
    setRequestDateTime(datetimeObject) {
      const requestDatetime = clone(datetimeObject);
      requestDatetime.endDatetime = getRequestDatetimeParams(requestDatetime.endDatetime);

      return requestDatetime;
    },
    onClickAbsoluteButton() {
      const datetimeObject = this.absoluteDatetime;
      this.setAbsoluteDatetime();

      const startDatetime = datetimeObject.startDate;
      const endDatetime = datetimeObject.endDate;

      if (startDatetime > endDatetime) {
        this.$alert('시작 날짜가 종료 날짜보다 클 수 없습니다.', '정보');
        return;
      }

      /*
        사용 정의 시간 선택의 경우 isRelative 값이 고려가 안되어 있어서 항상 false로 전달되는 결함 확인
        시간 범위 계산을 통해 isRelative 값을 추가하였음 - Song (2019.12.24)
       */
      const judgeDate = moment.duration(moment(endDatetime).diff(moment(startDatetime))).asHours();
      if (judgeDate <= 6) {
        datetimeObject.isRelative = true;
      } else {
        datetimeObject.isRelative = false;
      }

      if (this.isFlowAnalysis) {
        const startDate = moment(startDatetime);
        const endDate = moment(endDatetime);
        const diffHours = moment.duration(endDate.diff(startDate)).asHours();
        if (diffHours > 24) {
          this.$alert('24시간을 넘을 수 없습니다.', '정보');
          return;
        }
      }

      if (!isNil(this.maxDayValue)) {
        const startDate = moment(startDatetime);
        const endDate = moment(endDatetime);
        const diffDays = moment.duration(endDate.diff(startDate)).asDays();
        if (diffDays > this.maxDayValue) {
          this.$alert(`${this.maxDayValue} 일을 넘을 수 없습니다.`, '정보');
          return;
        }
      }

      this.onClickDate(datetimeObject);
    },
    /**
     * date-picker에서 미래시간은 선택하지 못한다.
     * @param  {[type]} datetime [description]
     * @return {[type]}          [description]
     * @author jda
     */
    disabledDate(datetime) {
      return datetime > Date.now();
    },
    /**
     * [사용자 정의 선택 시간]을 가공한다.
     * @author jda
     */
    setAbsoluteDatetime() {
      const absoluteDatetime = this.absoluteDatetime;

      const startDate = absoluteDatetime.startDate;
      const startTime = absoluteDatetime.startTime.split(':');
      startDate.setHours(parseInt(startTime[0]), parseInt(startTime[1]), 0, 0);

      const endDate = absoluteDatetime.endDate;
      const endTime = absoluteDatetime.endTime.split(':');
      endDate.setHours(parseInt(endTime[0]), parseInt(endTime[1]), 0, 0);
    },
    /**
     * 현재 dateTimeRange를 재선택 한다.
     * @return {[type]} [description]
     * @author jda
     */
    reloadDate() {
      this.onClickDate(this.dateTimeRange);
    },
    filterDayValue(btnInfo) {
      const maxValue = this.maxDayValue;

      if (isNil(maxValue)) {
        return true;
      }

      return (btnInfo.dayValue < maxValue);
    },
    setDefaultDatetime() {
      const defaultSetting = this.defaultDateTimeRange;
      const startDatetime = getIntervalDatetimeParams(new Date().getTime(), 'hour', 12);
      const endDatetime = new Date().getTime();

      const datetimeLabelValue = this.setDateTimeToString({
        startDatetime,
        endDatetime,
      });

      Object.assign(defaultSetting, {
        params: {
          startDatetime,
          endDatetime,
        },
        data: {
          startValue: startDatetime,
          startLabel: datetimeLabelValue.startDatetime,
          endValue: endDatetime,
          endLabel: datetimeLabelValue.endDatetime,
        },
      });

      this.dateTimeRange = defaultSetting;
      this.$store.dispatch('setAnalysisDateData', defaultSetting);
    },
  },
};
</script>

<style module>
.quick_datetime_button {
  margin-bottom: 4px;
  width: 100%;
  color: gray;
}

.time_picker_width {
  width: 120px !important;
}

.margin_r {
  margin-right: 4px;
}
.margin-b-10 {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/button/DatetimeRangeButton.vue